import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import NavigateBefore from '@mui/icons-material/NavigateBefore';
import NavigateNext from '@mui/icons-material/NavigateNext';
import { styled } from '@mui/material/styles';

const NavigationControls = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    whiteSpace: 'nowrap'
});

const CounterText = styled('span')({
    fontSize: '14px',
    fontWeight: 400,
    color: '#666',
    userSelect: 'none'
});

const NavArrowButton = styled(IconButton)({
    width: '28px',
    height: '28px',
    color: '#555',
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.06)',
        color: '#333'
    },
    '&.Mui-disabled': {
        color: 'rgba(0, 0, 0, 0.2)'
    }
});

type NavButtonProps = {
    onClick: () => void;
    disabled: boolean;
};

function PreviousImageButton({ onClick, disabled }: NavButtonProps) {
    return (
        <NavArrowButton
            aria-label="Previous image"
            onClick={onClick}
            disabled={disabled}
            size="small"
        >
            <NavigateBefore fontSize="small" />
        </NavArrowButton>
    );
}

function NextImageButton({ onClick, disabled }: NavButtonProps) {
    return (
        <NavArrowButton aria-label="Next image" onClick={onClick} disabled={disabled} size="small">
            <NavigateNext fontSize="small" />
        </NavArrowButton>
    );
}

type ImagePreviewNavigationProps = {
    onPrevious: () => void;
    onNext: () => void;
    canGoPrevious: boolean;
    canGoNext: boolean;
    counterLabel: string;
};

export function ImagePreviewNavigation({
    onPrevious,
    onNext,
    canGoPrevious,
    canGoNext,
    counterLabel
}: ImagePreviewNavigationProps) {
    return (
        <NavigationControls>
            <PreviousImageButton onClick={onPrevious} disabled={!canGoPrevious} />
            <CounterText>{counterLabel}</CounterText>
            <NextImageButton onClick={onNext} disabled={!canGoNext} />
        </NavigationControls>
    );
}
